import { ApiProperty } from "@nestjs/swagger";

export class InvetoryLogdDto{

    
    @ApiProperty()
    oldLocationId:number;

    @ApiProperty()
    newLocationId:number;

    @ApiProperty()
    oldSaleOrderId:number

    @ApiProperty()
    newSaleOrderId:number

    @ApiProperty()
    stockId:number

    @ApiProperty()
    oldQuantity:number 

    @ApiProperty()
    updatedQuantity:number

}